import { ChangeEvent, Fragment, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { Stack } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

import { useTopicStore, useTopicViewerStore } from '@/dmdrive/topic/components/Topic/TopicStore';
import SelectField from '@/dmdrive/ui-kit/components/SelectField/SelectField';

import {
  DM_INDUSTRIAL_SCALE,
  DM_RAINBOW_SCALE,
  PALETTE_PRESETS,
  PalettePreset,
} from '@carbon/dm-industrial/lib/dm-industrial';

import { PaletteControlRoot, PalettePreview } from './PaletteControl.styles';

const PALETTE_OPTIONS = [
  { value: PalettePreset.Default, title: 'Default' },
  // { value: PalettePreset.Palette1, title: 'Preset 1' },
  { value: PalettePreset.Rainbow, title: 'Rainbow' },
  // { value: PalettePreset.SteppedRainbow, title: 'Stepped Rainbow' },
];

function PaletteControl() {
  const { isControlDisabled } = useTopicStore();
  const { viewerSettings } = useTopicViewerStore();

  const { palettePreset, apply } = viewerSettings;

  const onChangePalette = useCallback(
    (e: ChangeEvent<HTMLInputElement>) =>
      apply({
        palettePreset: e.target.value as unknown as PalettePreset,
      }),
    [],
  );

  function renderHistogramContent(preset: PalettePreset) {
    switch (preset) {
      case PalettePreset.Rainbow:
        return <img src={DM_RAINBOW_SCALE} alt="" />;
      case PalettePreset.Default:
        return <img src={DM_INDUSTRIAL_SCALE} alt="" />;
      default:
        return (
          <Fragment>
            {Object.values(PALETTE_PRESETS[preset].colors).map((color, index) => (
              <div key={index} style={{ backgroundColor: `rgb(${color.r}, ${color.g}, ${color.b})` }} />
            ))}
          </Fragment>
        );
    }
  }

  return (
    <PaletteControlRoot>
      <SelectField
        label="Palette"
        onChange={onChangePalette}
        value={palettePreset}
        disabled={isControlDisabled}
        size="small"
        variant="standard"
      >
        {PALETTE_OPTIONS.map(({ value, title }) => (
          <MenuItem key={value} value={value}>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <PalettePreview>{renderHistogramContent(value)}</PalettePreview>

              <span>{title}</span>
            </Stack>
          </MenuItem>
        ))}
      </SelectField>
    </PaletteControlRoot>
  );
}

export default observer(PaletteControl);
